module.exports = __webpack_public_path__ + "static/media/pathcursor.dae848ee.svg";